import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Closing from './pages/Closing';

const Report = () => {
  return (
    <Routes>
      <Route path="closing/:id" element={<Closing />} />
    </Routes>
  );
};

export default Report;
